import { render, staticRenderFns } from "./CompleteOAuthProfileLayout.vue?vue&type=template&id=7434d934&"
import script from "./CompleteOAuthProfileLayout.vue?vue&type=script&lang=js&"
export * from "./CompleteOAuthProfileLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/branch.goz.fun/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7434d934')) {
      api.createRecord('7434d934', component.options)
    } else {
      api.reload('7434d934', component.options)
    }
    module.hot.accept("./CompleteOAuthProfileLayout.vue?vue&type=template&id=7434d934&", function () {
      api.rerender('7434d934', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Layouts/CompleteOAuthProfileLayout.vue"
export default component.exports